import { Graphics } from 'pixi.js';
import { Palette } from './Palette';

/** Glowing diamond with the always-visible 4px hitbox core dot. */
export function drawPlayer(): Graphics {
  const g = new Graphics();
  for (const [r, a] of [[26, 0.06], [21, 0.1], [17, 0.16]] as const) {
    g.poly([0, -r, r, 0, 0, r, -r, 0]).fill({ color: Palette.playerCool, alpha: a });
  }
  g.poly([0, -14, 14, 0, 0, 14, -14, 0]).fill({ color: Palette.playerCool, alpha: 0.9 });
  g.poly([0, -9, 9, 0, 0, 9, -9, 0]).fill({ color: Palette.playerCoolSoft });
  g.circle(0, 0, 4).fill(Palette.bulletCore);
  return g;
}
